import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ status: "polling", payment_status: "" });
  const tries = useRef(0);

  useEffect(() => {
    if (!sessionId) return;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState({ ...data, status: "done" }); return; }
        if (data.status === "expired") { setState({ ...data, status: "expired" }); return; }
        if (tries.current >= 10) { setState({ ...data, status: "timeout" }); return; }
        tries.current += 1;
        setTimeout(poll, 2000);
      } catch (e) {
        setState({ status: "error" });
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center" data-testid="payment-success-page">
      {state.status === "polling" && (
        <>
          <Loader2 className="w-12 h-12 text-[#264839] mx-auto animate-spin" />
          <h1 className="font-serif text-2xl text-[#11211A] mt-6">Confirming your payment…</h1>
          <p className="text-sm text-[#7D8C85] mt-2">Please don't close this window.</p>
        </>
      )}
      {state.status === "done" && (
        <>
          <CheckCircle2 className="w-12 h-12 text-[#264839] mx-auto" />
          <h1 className="font-serif text-2xl text-[#11211A] mt-6">Payment successful</h1>
          <p className="text-sm text-[#7D8C85] mt-2">Your listing has been upgraded.</p>
          <Link to="/dashboard" className="btn-primary mt-8 inline-flex" data-testid="back-to-dashboard">Back to dashboard</Link>
        </>
      )}
      {(state.status === "expired" || state.status === "timeout" || state.status === "error") && (
        <>
          <XCircle className="w-12 h-12 text-[#B35C4A] mx-auto" />
          <h1 className="font-serif text-2xl text-[#11211A] mt-6">Payment not completed</h1>
          <Link to="/dashboard" className="btn-primary mt-8 inline-flex">Back to dashboard</Link>
        </>
      )}
    </div>
  );
}
